import { useState, useEffect } from "react";
import BarGraph from "../UI/BarGraph";
import { requestAdminAPI } from "../../api/posh-api";
import Heading from "../UI/Heading";
import LoaderGraph from "../UI/LoaderGraph";
import ExportCsvButton from "../UI/ExportCsvButton";
import { MdRefresh } from "react-icons/md";

/** ========================================================================
 * * Vehicles Revenue Graph
 * Renders a component, which displays a vehicle's revenue in a graph.
 * ========================================================================== */

export default function VehiclesRevenue({
  vehicleId,
  heading = "Vehicles Revenue",
}) {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [data, setData] = useState([]);
  const [type, setType] = useState("distributed");
  const [include, setInclude] = useState("");
  const [loading, setLoading] = useState(true);

  // ============================================= FETCH REVENUE FOR VEHICLES
  const fetchRevenueHandler = async () => {
    try {
      setLoading(true);
      const data = await requestAdminAPI("fetch-vehicle-revenue", {
        year: selectedYear,
        vehicleId,
        type,
        include,
      });
      setData(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vehicleId) fetchRevenueHandler();
  }, [selectedYear, vehicleId, type, include]);

  return (
    <div>
      <Heading title={heading} isBackArrow={false}>
        <select
          className="text-sm bg-transparent border-b rounded-none cursor-pointer input"
          value={include}
          onChange={(e) => setInclude(e.target.value)}
        >
          <option value="">All</option>
          <option value="booking">Bookings</option>
          <option value="deposit">Deposits</option>
          <option value="toll">Tolls</option>
          <option value="violation">Violation</option>
        </select>
        <select
          className="text-sm bg-transparent border-b rounded-none cursor-pointer input"
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="distributed">Distributed</option>
          <option value="dateCreated">Date Created</option>
          <option value="datePaid">Date Paid</option>
        </select>
        <select
          className="text-sm bg-transparent border-b rounded-none cursor-pointer input"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          {Array.from(
            { length: new Date().getFullYear() - 2022 + 1 },
            (_, i) => {
              return (
                <option key={i} value={2022 + i}>
                  {2022 + i}
                </option>
              );
            }
          )}
        </select>
        <ExportCsvButton
          array={data}
          filename={heading?.replaceAll(" ", "-").toLowerCase()}
        />
        <MdRefresh onClick={fetchRevenueHandler} className="icon" />
      </Heading>
      {loading ? <LoaderGraph /> : <BarGraph data={data} />}
    </div>
  );
}
